import React from 'react';
import { Modal } from 'react-bootstrap';
import { Dt_linkSentIcon } from '../../../../../components/icons';

const DoctubeShareModal = ({ title = 'fff', subtitle, linkSentShow, handleClose }) => {
  // console.log('inside modal', title);
  return (
    <Modal
      className="centerModal dt_linkSentModal"
      size="md"
      centered
      show={linkSentShow}
      onHide={handleClose}
    >
      <Modal.Body className="p-0">
        <div className="dt_linkSentModal_body text-center position-relative py-50 px-5">
          <div
            className="closeIcon position-absolute d-flex justify-content-center align-items-center fs-2 fw-medium text-black bg-light rounded-circle"
            onClick={handleClose}
          >
            X
          </div>
          <Dt_linkSentIcon customClass={'my-0 mx-auto'} />
          <h4 className="fs-3 fw-medium text-black mt-5">
            {/* You have received a link in your email and phone. Please click on the link to activate
            your account */}
            {title}
          </h4>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default DoctubeShareModal;